import { FC, MutableRefObject, ReactNode } from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import moment from 'moment/moment';
import appLogo from '../../assets/appLogo.png';
import { useAppSelector } from '../../hooks/useAppStore';
import { getIsPrintMode } from '../../store/common/selectors';

type TPrintWrapper = {
  componentRef: MutableRefObject<HTMLDivElement | null>
  children: ReactNode;
};

const PrintWrapper: FC<TPrintWrapper> = ({ componentRef, children }) => {
  const isPrintMode = useAppSelector(getIsPrintMode);
  return (
    <Stack px={isPrintMode ? 4 : 0} ref={componentRef}>
      {isPrintMode && (
      <Stack
        flexDirection="row"
        pt={2}
        alignItems="center"
        justifyContent="space-between"
      >
        <img src={appLogo} width={70} height={70} alt="appLogo" />
        <Typography color="primary" fontSize={20}>
          {moment().format('DD MMMM, hh:mm A')}
        </Typography>
      </Stack>
      )}
      {children}
    </Stack>
  );
};

export { PrintWrapper };
